import { createContext } from "react";

export const MapContext = createContext({ instId: null, locId: null });
